// import VT from '@/store/types';

export default {
  // [VT.PROJECT_USERS_LIST]: (state, { data, status }) => {
  //   state.projectUsersList = { data, status };
  // },
};
